import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { RoleCheckGuard } from '@shared/guards/role-check/role-check.guard';
import { SequentialGuard } from '@shared/guards/sequential/sequiential.guard';
import { XpoLtlAuthGuard } from '@xpo-ltl/ngx-auth';
import { XpoAuthenticationGuard } from '@xpo/ngx-auth';
import { ReweighLogHeaderViewsComponent } from '../reweigh-log-header-views/reweigh-log-header-views.component';

const authGuards = !!window['Cypress'] ? [] : [XpoAuthenticationGuard, XpoLtlAuthGuard];

const routerDefinitions: Routes = [
  {
    path: 'reweigh-log-summary/:logHeaderId',
    component: ReweighLogHeaderViewsComponent,
    canActivate: [SequentialGuard],
    data: {
      sequentialGuards: [...authGuards, RoleCheckGuard],
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routerDefinitions)],
})
export class ReweighLogSummaryRoutingModule {}
